require('dotenv').config({
  path: './.env.local'
});

const uk = require('./src/locales/uk.js');
const en = require('./src/locales/en.js');
const pl = require('./src/locales/pl.js');
const cz = require('./src/locales/cz.js');

const translations = {
  'uk': uk,
  'en': en,
  'pl': pl,
  'cz': cz
};

const DEFAULT_LANG = 'uk';

class Helpers {
  getCurrentLang() {
    return localStorage.getItem('lang') || DEFAULT_LANG;
  }

  setLang(lang) {
    localStorage.setItem('lang', lang);
  }

  getLocaleTranslations(lang = this.getCurrentLang()) {
    return translations[lang] || translations[DEFAULT_LANG];
  }

  /**
   * Локалізована назва бейджа: переклад для поточної мови,
   * з фолбеком на базове `name`, якщо переклад порожній.
   * @param {{name?: string, translations?: {uk?: string, en?: string, pl?: string, cz?: string}}} badge
   * @param {string} lang
   * @returns {string}
   */
  getBadgeName(badge, lang = this.getCurrentLang()) {
    if (!badge) return '';
    const translated = badge.translations && badge.translations[lang];
    return (translated && translated.trim()) || badge.name || '';
  }

  convertTime(time, locale = 'uk-UA') {
    return new Date(time).toLocaleString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  timeSince(date, lang = this.getCurrentLang()) {
    const now = new Date();
    const dateObject = new Date(date);
    const diff = now - dateObject;

    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);

    const t = this.getLocaleTranslations(lang).time;

    if (minutes < 60) {
      return minutes > 1 ? `${minutes} ${t.minutes}` : t.minute;
    } else if (hours < 24) {
      return hours > 1 ? `${hours} ${t.hours}` : t.hour;
    } else if (days < 7) {
      return days > 1 ? `${days} ${t.days}` : t.day;
    } else if (weeks < 4) {
      return weeks > 1 ? `${weeks} ${t.weeks}` : t.week;
    } else {
      return months > 1 ? `${months} ${t.months}` : t.month;
    }
  }

  formatFullDate(dateString) {
    if (!dateString) return '';

    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat('uk-UA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });

    return formatter.format(date).replace(',', '');
  }

  getMinutesSince(date) {
    const now = new Date();
    const dateObject = new Date(date);
    const diff = now - dateObject;
    return Math.floor(diff / 60000);
  }

  customReplace(match, replace, string) {
    const regex = new RegExp(match, 'g');
    return string.replace(regex, replace);
  }

  /**
   * Список програм, у яких може бути зібране лекало.
   * Єдине джерело істини для селекта, бейджів і аудит-логу (клієнт + сервер).
   * @returns {{value: string, label: string}[]}
   */
  get assemblyPrograms() {
    return [
      { value: '3m', label: '3М' },
      { value: 'haut', label: 'Haut' },
      { value: 'brawixcut', label: 'BrawixCut' },
      { value: 'slabyte', label: 'SlaByte' },
      { value: 'autopatterns', label: 'Autopatterns' },
      { value: 'xpel', label: 'Xpel' }
    ];
  }

  getAssemblyProgramLabel(value) {
    const program = this.assemblyPrograms.find(p => p.value === value);
    return program ? program.label : '';
  }

  // Мітки для списку програм (напр., у бейджах/логах): "3М, BrawixCut"
  getAssemblyProgramLabels(values) {
    if (!Array.isArray(values)) return '';
    return values.map(v => this.getAssemblyProgramLabel(v)).filter(Boolean).join(', ');
  }

  parseSortParams(sortParams) {
    const parsedSort = {};

    for (const key in sortParams) {
      if (sortParams[key]) {
        const value = parseInt(sortParams[key]);
        if (key in sortParams) {
          parsedSort[key] = isNaN(value) ? 1 : value;
        }
      }
    }
    return parsedSort;
  }

  getLastCharacters(inputString, length = 4) {
    if (!inputString) {
      return '';
    }
    if (inputString.length >= length) {
      return inputString.slice(-length);
    } else {
      return inputString;
    }
  }

    /**
     * @returns {string}
     */
    generateCustomId() {
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const firstLetter = letters.charAt(Math.floor(Math.random() * letters.length));
        const secondLetter = letters.charAt(Math.floor(Math.random() * letters.length));
        const numbers = Math.floor(Math.random() * 10000).toString().padStart(4, '0'); // 0000-9999
        return `${firstLetter}${secondLetter}${numbers}`;
    }

    /**
     * @param {mongoose.Model} model
     * @param {string} field
     * @returns {Promise<string>}
     */
    async generateUniqueOrderId(model, field) {
        const id = this.generateCustomId();
        const exists = await model.exists({[field]: id});
        if (exists) {
            return this.generateUniqueOrderId(model, field);
        }
        return id;
    }

    addImageSize(url, size) {
    if (!url) {
      return null;
    }

    if (!url.includes(process.env.VUE_APP_WEB_PUSH_APP_URL)) {
      return process.env.VUE_APP_WEB_PUSH_APP_URL + '/' + url + '?size=' + size;
    } else {
      return url + '?size=' + size;
    }
  }
}

module.exports = new Helpers();